<ng-container *transloco="let t">
  <div class="order-date">
    <pxw-icon icon="clock" size="xs"></pxw-icon>
    {{ formattedDate() }}
  </div>

  <!-- CUSTOMER -->
  <pxw-order-details-section
    [title]="t('orderDetails.customerData')"
    [editEnabled]="editEnabled()"
    (edit)="editCustomerData.emit()"
  >
    <pxw-icon icon="users" size="sm" />
    <pxw-order-details-customer
      [name]="orderDetails().personalInformation.name || null"
      [phone]="orderDetails().personalInformation.phone || null"
      [whatsappButtonEnabled]="whatsappButtonEnabled()"
    />
  </pxw-order-details-section>

  <!-- SHIPPING TODO: CHECK ENABLED SHIPPING -->
  @let shippingOption = orderDetails().shippingOption;

  @if (editEnabled() || shippingOption) {
    <pxw-order-details-section
      [title]="t('orderDetails.shippingOptionData')"
      [editEnabled]="editEnabled()"
      [disabledEditTooltip]="orderWasShipped() ? t('orderDetails.orderWasShippedError') : null"
      (edit)="editShippingOption.emit()"
    >
      <pxw-icon icon="shipping" size="sm" />
      @if (shippingOption) {
        <pxw-order-details-shipping-option
          [shippingOption]="shippingOption"
          [address]="orderDetails().personalInformation.address || null"
          [shippingEstimate]="orderDetails().shippingEstimate || null"
          [shippingOrder]="orderDetails().shippingOrder || null"
          [tableNumber]="orderDetails().tableNumber || null"
          [displayShippingEstimate]="displayShippingEstimate()"
          [isShippingRequestInProgress]="isShippingRequestInProgress()"
          (confirmShipping)="confirmShipping.emit()"
          (createShipping)="createShipping.emit()"
          (cancelShipping)="cancelShipping.emit()"
        />
      } @else {
        <pxw-alert type="neutral" size="sm" display="inline-block" appareance="bare">
          {{ t('orderDetails.emptyShippingOption') }}
        </pxw-alert>
      }
    </pxw-order-details-section>
  }

  <!-- PAYMENT (always displayed because it shows order totals) -->
  <pxw-order-details-section
    [title]="t('orderDetails.paymentMethodData')"
    [editEnabled]="editEnabled()"
    (edit)="editPaymentMethod.emit()"
  >
    <pxw-icon icon="payment" size="sm" />

    @let paymentMethod = orderDetails().paymentMethod;

    @if (paymentMethod) {
      <pxw-order-details-payment-method
        [orderId]="orderDetails().id!"
        [paymentMethod]="paymentMethod"
        [paymentLink]="orderDetails().paymentLink || null"
        [howMuch]="orderDetails().howMuch || null"
      />
    }
    <div class="order-section-item order-totals">
      <div class="order-section-item-title">
        {{ t('orderDetails.total') }}
        @if (displayTotalDetails()) {
          <span class="show-total-details" (click)="showTotalDetails()">
            {{ t('orderDetails.viewTotalDetails') }}
          </span>
        }
      </div>
      <div class="order-section-item-value">
        {{ orderDetails().finalAmount | currencyFormat }}
      </div>
    </div>
  </pxw-order-details-section>

  <!-- CUSTOM FIELDS -->
  @let customFieldDetails = orderDetails().customFieldDetails;
  @let hasCustomFields = customFieldDetails && customFieldDetails.length > 0;

  @if (editEnabled() || hasCustomFields) {
    <pxw-order-details-section
      [title]="t('orderDetails.customFieldsData')"
      [editEnabled]="editEnabled()"
      [disabledEditTooltip]="!hasCustomFields ? t('orderDetails.noCustomFieldsError') : null"
      (edit)="editCustomFields.emit()"
    >
      <pxw-icon icon="form" size="sm" />
      @if (hasCustomFields) {
        <pxw-order-details-custom-fields [customFieldDetails]="customFieldDetails" />
      } @else {
        <pxw-alert type="neutral" size="sm" display="inline-block" appareance="bare">
          {{ t('orderDetails.emptyCustomFields') }}
        </pxw-alert>
      }
    </pxw-order-details-section>
  }

  <!-- COUPON: TODO: CHECK ENABLED COUPONS -->
  @let couponConfigurationSnapshot = orderDetails().couponConfigurationSnapshot;

  @if (editEnabled() || couponConfigurationSnapshot) {
    <pxw-order-details-section
      [title]="t('orderDetails.discountsData')"
      [editEnabled]="editEnabled()"
      (edit)="editCoupon.emit()"
    >
      <pxw-icon icon="price-discount" size="sm" />
      @if (couponConfigurationSnapshot) {
        <div class="order-section-item">
          <div class="order-section-item-title">
            {{ t('orderDetails.couponDiscount') }}
          </div>
          <div class="order-section-item-value">
            {{ couponConfigurationSnapshot.code }}
          </div>
        </div>
      } @else {
        <pxw-alert type="neutral" size="sm" display="inline-block" appareance="bare">
          {{ t('orderDetails.emptyDiscounts') }}
        </pxw-alert>
      }
    </pxw-order-details-section>
  }
  <!-- PRODUCTS -->
  <pxw-order-details-section
    [title]="t('orderDetails.products')"
    [editEnabled]="editEnabled()"
    (edit)="editCart.emit()"
  >
    <pxw-icon icon="checkout" size="sm" />
    <pxw-cart-items-list
      [cartItems]="orderDetails().cartItems"
      [undefinedGroupName]="t('product.undefinedGroupName')"
    >
      <ng-template #itemTemplate let-cartItem>
        <pxw-resume-item [cartItem]="cartItem" [small]="true" [displaySku]="displaySku()" />
      </ng-template>
    </pxw-cart-items-list>
  </pxw-order-details-section>

  <pxw-modal-dialog
    #totalDetailsDialog
    icon="info"
    [title]="t('totalDetails.title')"
    type="modal"
    [showCloseButton]="true"
  >
    <app-order-total-details [orderTotals]="orderDetails()" />
  </pxw-modal-dialog>
</ng-container>
